import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ArmyBanner,
  ArmyRegiment,
  GeneralType,
  GovernyInfo
} from "../../../../lib/types";
import AttributeIcon from "./AttributeIcon";
import { formatNumber } from "../../../../lib/commonFunctions";
import { GENERAL_TYPE, systemClass } from "../../../../lib/enums";

import { portraits } from "../../../../assets/images/races";
import ArmyRegimentPerson from "./ArmyRegimentPerson";
import { DragescentState } from "../../../../store/reducers/stateType";
import { assignBannerGeneral, releaseBannerGeneral } from "../../../../store/actions";

interface IProps {
  governorate?: GovernyInfo;
  position: string;
  tactics: number;
  banner?: ArmyBanner;
  ownPosition: boolean;
  availableSoldier: boolean;
}

const ArmyBannerPerson = ({
  governorate,
  position,
  tactics,
  banner,
  ownPosition,
  availableSoldier
}: IProps) => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const soldierGeneral = useSelector((state: DragescentState) => state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.SOLDIER).general);
  const dispatch = useDispatch();

  const [target, setTarget] = useState(banner?.target || position);

  return (
    <div
      className={`person ${systemClass.MatchHeight} ${!ownPosition && governorate ? "grey-wrap" : ""} ${ownPosition ? " selected" : ""}`}
    >
      {governorate
        ? <img src={portraits[governorate.race.name]} alt="" className="photo"/>
        : <i className="icon-banner icon-xlg icon middle grey"
             style={{ height: "50px", width: "50px", marginBottom: "25px" }}/>
      }
      <h3 className={"name"}>
        {position}
      </h3>
      <div style={{ height: "85px" }}>
        <div>General</div>
        {banner?.general?.general
          ? <><em>{banner.general.general.governy.name}'s</em> soldier</>
          : "Not assigned"}
        {banner?.general?.general && banner.general.general.id === soldierGeneral?.id
        && <div>
          <a
            className={"link"}
            onClick={() => dispatch(releaseBannerGeneral(banner.id))}
          >
            Release general
          </a>
        </div>}
        {banner && !banner?.general?.general && availableSoldier
        && <div>
          <a
            className={"link"}
            onClick={() => dispatch(assignBannerGeneral(banner.id))}
          >
            Assign general
          </a>
        </div>}
      </div>
      <p>Target</p>
      <div className="dropdown no-margin-forced">
        <select onChange={e => setTarget(e.target.value)} className="input" value={target}>
          <option value="left" selected={target === "left"}>Left</option>
          <option value="center" selected={target === "center"}>Center</option>
          <option value="right" selected={target === "right"}>Right</option>
        </select>
      </div>
      <br/>
      <p>
        <p>
          <span className="white">Attack</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"utok"}
            title={"Attack"}
            content={"attack power, ability to hit"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.attack || 0)}</em><br/>
          <span className="white">Defence</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"obrana"}
            title={"Defence"}
            content={"defense power, ability to block hits"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.defence || 0)}</em><br/>
          <span className="white">Piercing</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"piercing"}
            title={"Piercing"}
            content={"ability to overcome armor"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.piercing || 0)}</em><br/>
          <span className="white">Armor</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"armor"}
            title={"Armor"}
            content={"reduces damage by 25% unless it’s pierced"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.armor || 0)}</em><br/>
          <span className="white">Ranged Attack</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"ranged-attack"}
            title={"Ranged attack"}
            content={"ranged attack power, ability to hit targets in range phase"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.rangedAttack || 0)}</em><br/>
          <span className="white">Range</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"range"}
            title={"Range"}
            content={"distance from which the unit engages in range phase"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.range || 0)}</em><br/>
          <span className="white">Charge</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"dalsi-tah-5"}
            title={"Charge"}
            content={"force of initial attack"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.charge || 0)}</em><br/>
          <span className="white">Speed</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"dalsi-tah-6"}
            title={"Speed"}
            content={"adaptability and mobility of unit"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.speed || 0)}</em><br/>
          <span className="white">Stamina</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"totem"}
            title={"Stamina"}
            content={"endurance of unit during the battle"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.stamina || 0)}</em><br/>
          <span className="white">Morale</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"armada"}
            title={"Morale"}
            content={"mental resistance to damage"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.morale || 0)}</em><br/>
          <span className="white">HP</span>&nbsp;&nbsp;
          <AttributeIcon
            icon={"hit-points"}
            title={"Hit points"}
            content={"hit points, physical resistance to damage"}
            className={"align-sub"}
          />
          &nbsp;&nbsp;
          <em>{formatNumber(banner?.hp || 0)}</em><br/>
          {/* <span className="white">Wall Attack</span>&nbsp;&nbsp; */}
          {/* <AttributeIcon */}
          {/*  icon={"wall-attack"} */}
          {/*  title={"Wall Attack"} */}
          {/*  content={"ability to breach wall defence after victorious battle"} */}
          {/*  className={"align-sub"} */}
          {/* /> */}
          {/* &nbsp;&nbsp; */}
          {/* <em>{formatNumber(banner?.wallAttack || 0) : "-"}</em><br/> */}
          {/* <span className="white">Wall Defence</span>&nbsp;&nbsp; */}
          {/* <AttributeIcon */}
          {/*  icon={"wall-attack"} */}
          {/*  title={"Wall Defence"} */}
          {/*  content={"ability to persist wall attack"} */}
          {/*  className={"align-sub"} */}
          {/* /> */}
          {/* &nbsp;&nbsp; */}
          {/* <em>{banner.attributes
          ? formatNumber(banner.attributes.wallDefence || 0) : "-"}</em><br/> */}
        </p>

        <h3 className={`name`}>REGIMENTS</h3>
        <ArmyRegimentPerson
          regiment={Object.values(banner?.regiments || {})?.find(r => r.governy.id === id)}
          own={true}
          position={position}
          target={target}
          tactics={tactics}
          bannerUnits={Object.values(banner?.regiments || {})
            .reduce((sum: number, r: ArmyRegiment) => sum += Object.values(r.units)
              .reduce((units, u) => units += u.amount, 0), 0)}
        />
        <span className={"divider"} />
        {
          Object.values(banner?.regiments || {})?.filter(r => r.governy.id !== id).map(r => <>
            <ArmyRegimentPerson
              regiment={r}
              position={position}
              target={target}
              tactics={tactics}
              bannerUnits={Object.values(banner?.regiments || {})
                .reduce((sum: number, r1: ArmyRegiment) => sum += Object.values(r1.units)
                  .reduce((units, u) => units += u.amount, 0), 0)}
            />
            <span className={"divider"} />
          </>)
        }
      </p>
    </div>
  )
}

export default ArmyBannerPerson;
